export default __webpack_public_path__ + "7fe9927119b00fc5cac50cb1c9ad95a5.png";